var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{attrs:{"solo":"","label":_vm.label},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }